import { useNavigate } from 'react-router-dom';
import { Button, message, Row, Typography } from 'antd';
import { useDispatch } from 'react-redux';
import { forgotPassword,
  forgotPasswordClear,
  forgotPasswordErrorClear } from '@triare/auth-redux/dist/saga/auth/forgotPassword';
import { useEffect } from 'react';
import { LogoSmall } from '../../../../Common/Icon';

import styles from './index.module.scss';
import { useAuth } from '../../../../../store/auth';

export default function SendSuccess({ email }: { email: string }) {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const { forgotPassword: forgotPasswordState } = useAuth();

  useEffect(() => {
    if (forgotPasswordState.response) {
      message
        .success('A reset password link has been sent to your email address.')
        .then(() => dispatch(forgotPasswordClear()));
    }
  }, [forgotPasswordState.response]);

  useEffect(() => {
    if (forgotPasswordState.error) {
      message.error(JSON.stringify(forgotPasswordState.error.message)).then(() => dispatch(forgotPasswordErrorClear()));
    }
  }, [forgotPasswordState.error]);

  return (
    <>
      <Row justify="center">
        <LogoSmall />
      </Row>
      <Typography.Title level={5} className={styles.title}>
        Please check your email
      </Typography.Title>
      <Typography.Paragraph className={styles.secondary} type="secondary">
        A reset password link has been sent to your email address.
      </Typography.Paragraph>
      <Button
        size="large"
        type="link"
        style={{ color: '#1677FF' }}
        block
        onClick={() => dispatch(forgotPassword({ email }))}
        loading={forgotPasswordState.loading}
      >
        Resend verification email
      </Button>
      <Button size="large" type="link" style={{ color: '#1677FF' }} block onClick={() => navigate('/sign-in')}>
        Back to log in
      </Button>
    </>
  );
}
